import type { Koordinaten } from "../../types";

export function locationRounder(precision: number) {
  const factor = Math.pow(10, precision);
  const round = (value: number) => Math.round(value * factor) / factor;

  return (location: Koordinaten) => ({
    latitude: round(location.latitude),
    longitude: round(location.longitude),
  });
}
